
import TableList from "@components/templates/tablelist";
import { HttpPlanBillDeliver } from "@/service/allotment";
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
        };
    },
    methods: {
        ajaxRequest: HttpPlanBillDeliver,
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t('fbb.allotmant.inbound', { defaultValue: '调拨出库单号' }),
                    key: 'transferOutboundNo',
                },
                {
                    title: 'Tracking NO',
                    key: 'trackingNo',
                },
                {
                    title: this.$t('fbb.alloment.carrier_code', { defaultValue: '承运商' }),
                    key: 'carrierCode',
                },
                {
                    title: this.$t('fbb.alloment.appointment_date', { defaultValue: '预约送仓时间' }),
                    key: 'appointmentAt',
                },
                {
                    title: this.$t('fbb.alloment.appointment_ship_at', { defaultValue: '预约提货时间' }),
                    key: 'appointmentShipAt',
                },
                {
                    title: this.$t('fbb.alloment.tray_bar_code', { defaultValue: '托盘码' }),
                    key: 'palletBarcode',
                },
                {
                    title: this.$t('fbb.inbound.case_code', { defaultValue: '箱码' }),
                    key: 'cartonBarcode',
                },
                {
                    title: this.$t('fbb.alloment.actual_ship_at', { defaultValue: '实际提货时间' }),
                    key: 'actualShipAt',
                }
            ];
        },

    },

};
